// modules
import { createAction } from 'redux-actions'

// Reducer
export const QUEUE_PUSH = 'QUEUE_PUSH'
/**
 * use retry=-1 for infinite retries
 * @type {actionCreator}
 */
export const queuePush = createAction(
  QUEUE_PUSH,
  (data, { save = false, retry = 1 } = {}) => ({
    data,
    save,
    retry,
  }),
)

export const QUEUE_ACK = 'QUEUE_ACK'
export const queueAck = createAction(QUEUE_ACK) // (ack)

export const QUEUE_REMOVE_UNSAVED = 'QUEUE_REMOVE_UNSAVED'
export const queueRemoveUnsaved = createAction(QUEUE_REMOVE_UNSAVED)

export const QUEUE_EMPTY = 'QUEUE_EMPTY'
export const queueEmpty = createAction(QUEUE_EMPTY)

export const QUEUE_RETRY_DEC = 'QUEUE_RETRY_DEC'
export const queueRetryDec = createAction(QUEUE_RETRY_DEC)

// Effect
export const QUEUE_SEND = 'QUEUE_SEND'
export const queueSend = createAction(QUEUE_SEND)
